import { CampusStakeDetails } from "./campus-stake-details.model";

export class CampusStakeDetailsForUpdate extends CampusStakeDetails {
  password: string;
}
